/* eslint-disable no-undef */
import { Controller } from 'stimulus';
import { triggerCustomEvent } from 'lib/helpers';

export default class AdsController extends Controller {
  connect() {
    const adScriptCheck = setInterval(() => {
      if (window.googletag && googletag.apiReady) {
        window.googletag = googletag || {};

        clearInterval(adScriptCheck);
      }
    }, 100);

    window.addEventListener('ResetAds', this.resetAds);
  }

  disconnect() {
    triggerCustomEvent('ResetAds');

    window.removeEventListener('ResetAds', this.resetAds);
  }

  resetAds = () => {
    if (googletag) {
      googletag.destroySlots();
    }
  }
}
/* eslint-enable no-undef */
